import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import { firebaseConfig } from "./firebase-config";
import { unMachine } from "./filters";
import VueAnnouncer from "vue-announcer";
import "firebase/firestore";
import { mapMutations } from "vuex";
import { trackSessionStart, trackSessionEnd } from "./utils/analytics";

Vue.config.productionTip = false;

// Filters.
Vue.filter("unMachine", unMachine);

// Vue announcer.
Vue.use(VueAnnouncer, {}, router);

// Main vue instance.
new Vue({
  router,
  store,

  methods: {
    ...mapMutations(["setDB", "setAnalytics", "setUID"]),
  },

  created() {
    firebase.initializeApp(firebaseConfig);
    this.setAnalytics(firebase.analytics());

    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.$router.push("/auth");
      } else {
        // User is authenticated, set UID in store
        this.setUID(user.uid);

        // Track session start on app load (for returning users)
        // Note: Auth.vue also tracks this on fresh login
        if (this.$router.currentRoute.path !== "/auth") {
          trackSessionStart(user.uid);
        }
      }
    });

    // Set database object.
    this.setDB(firebase.firestore());

    // Enable persistence.
    firebase.firestore().enablePersistence();

    // Track session end on page unload
    window.addEventListener("beforeunload", () => {
      const uid = this.$store.getters.getUID;
      if (uid) {
        trackSessionEnd(uid);
      }
    });
  },

  render: (h) => h(App),
}).$mount("#app");
